import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    name: "hafez",
    childs: ["shakira", "biance"],
  },
  reducers: {
    addChilde: (state, action) => {
      const newChilds = action.payload.filter(
        (child) => !state.childs.includes(child)
      );
      state.childs.push(...newChilds);
    },
  },
});
export const { addChilde } = userSlice.actions;
export default userSlice.reducer;
